module.exports = __webpack_public_path__ + "static/media/parking-car.71785121.svg";